import {
  type EnvironmentProviders,
  computed,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { TUI_LANGUAGE } from '@taiga-ui/i18n/tokens';
import { TUI_ENGLISH_LANGUAGE } from '@taiga-ui/i18n/languages/english';
import { TUI_GERMAN_LANGUAGE } from '@taiga-ui/i18n/languages/german';

import { I18nService } from './i18n.service';

/**
 * Wires Taiga UI's own strings to the application's language.
 *
 * Taiga ships its component copy — calendar months, pagination labels, the
 * "more" in a truncated list — as its own dictionaries, and `TUI_LANGUAGE`
 * takes a signal, so it follows the same source as everything else.
 *
 * Taiga has no Norwegian bundle (23 languages, and that is not one of them),
 * so Norwegian falls back to English for those built-in strings only. The
 * application's own copy is unaffected.
 */
export function provideI18n(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => inject(I18nService).initialize()),
    {
      provide: TUI_LANGUAGE,
      useFactory: () => {
        const i18n = inject(I18nService);

        return computed(() =>
          i18n.language() === 'de' ? TUI_GERMAN_LANGUAGE : TUI_ENGLISH_LANGUAGE,
        );
      },
    },
  ]);
}
